
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.178 10.806c0-1.22.262-2.418.787-3.593.525-1.175 1.129-2.124 1.812-2.847a14.733 14.733 0 012.204-2.034c.84-.633 1.47-1.062 1.89-1.288.42-.226.709-.385.866-.475l2.127 1.898c-.316.226-.71.565-1.182 1.017-.577.588-1.155 1.334-1.732 2.238-.735 1.04-1.05 1.966-.945 2.78 1.155.135 2.126.587 2.914 1.355.787.769 1.18 1.673 1.18 2.712 0 1.13-.472 2.08-1.417 2.847-.892.769-1.994 1.153-3.307 1.153-1.522 0-2.782-.52-3.78-1.56-.945-1.084-1.417-2.485-1.417-4.203zm-12.678 0c0-1.22.262-2.418.787-3.593.525-1.175 1.13-2.124 1.812-2.847a14.733 14.733 0 012.204-2.034c.84-.633 1.47-1.062 1.89-1.288.42-.226.709-.385.866-.475l2.127 1.898c-.315.226-.71.565-1.182 1.017-.577.588-1.154 1.334-1.732 2.238-.735 1.04-1.05 1.966-.945 2.78 1.155.135 2.126.587 2.914 1.355.787.769 1.18 1.673 1.18 2.712 0 1.13-.472 2.08-1.417 2.847-.892.769-1.994 1.153-3.307 1.153-1.522 0-2.782-.52-3.78-1.56C.972 13.926.5 12.525.5 10.807z","fill":"#ABAFB5"}})])
          )
        }
      }
    